const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.click();
            observer.unobserve(entry.target);
        }
    });
}, { threshold: 0.1 });

const project_filter_els = document.querySelectorAll('.project-filter .list');

if (project_filter_els.length > 0) {
    const project_filter_el = project_filter_els[0];

    observer.observe(project_filter_el);
}

document.querySelector('.woocommerce-Button--info')?.addEventListener('click', function () {
    this.closest('form').submit();
});